/*
    반품쟁이 사이드바 '연관 서비스' 목록.
    key -> iframe 패널로 표시할 URL 매핑.
    URL 쿼리파라미터(panelUrl)에는 key 값만 노출되며, 임의 URL 주입을 막기 위해
    실제 iframe src 는 이 목록에서만 조회한다.
*/
export const RELATED_SERVICES = [
    {
        key: 'logen',
        name: '로젠 반품 대시보드',
        url: 'https://ilogen-delivery.sellertool.io/',
    },
    {
        key: 'erp',
        name: '셀러툴 통합발주관리',
        url: 'https://www.sellertool.io/erp/collection/dashboard',
    },
];

export function findRelatedServiceByKey(key) {
    return RELATED_SERVICES.find(service => service.key === key) || null;
}

/*
    'panels' 쿼리파라미터(콤마 구분 문자열)를 열린 서비스 key 배열로 변환.
    - 중복 제거, 등록되지 않은 key 제외, 순서(탭 순서) 유지.
*/
export function parseOpenServiceKeys(panelsParam) {
    if (!panelsParam) {
        return [];
    }

    const seen = new Set();
    return panelsParam
        .split(',')
        .map(key => key.trim())
        .filter(key => {
            if (!key || seen.has(key)) {
                return false;
            }
            if (!RELATED_SERVICES.some(service => service.key === key)) {
                return false;
            }
            seen.add(key);
            return true;
        });
}
